const CollectionSlider = function() {
    function CollectionSlider() {
        this.selector = {
            container: document.querySelectorAll(".collection-slider")
        }
        this.load();        
    }
    CollectionSlider.prototype.load = function() {
        var _ = this;
        let loaded = false;
        window.addEventListener("scroll", async function() {
            if(_.selector.container.length > 0 && !loaded && window.scrollY > 10) {
                _.selector.container.forEach(el => {
                   el.innerHTML = el.dataset.content;
                })
              loaded = true;
            }
        })

    }
    CollectionSlider = new CollectionSlider;
}

CollectionSlider();